<div class="d-flex text-accent" [ngClass]="textClass">
  <app-icon
    class="mr-8"
    [icon]="icon"
    [isSelected]="true"
    [matTooltip]="iconTooltip"
  >
  </app-icon>
  <span class="font-weight-bold">{{ yellowFlag.title }}</span>
</div>

<p>
  <span markdown>{{ yellowFlag.explanation }}</span>
</p>

@if (devices.length !== 0) {
<div class="mb-8">
  <span class="mr-8">Applies to:</span>
  @for (device of devices; track device) {
  <mat-chip-option class="mr-8">
    {{ device }}
  </mat-chip-option>
  }
</div>
}
